import { FC, MouseEvent, useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface OrganizationActionsMenuProps {
  onEdit: () => void;
  onDelete: () => void;
}

const OrganizationActionsMenu: FC<OrganizationActionsMenuProps> = ({
  onEdit,
  onDelete,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleEdit = () => {
    handleClose();
    onEdit();
  };

  const handleDelete = () => {
    handleClose();
    onDelete();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <IconButton
        aria-label="more"
        id="organization-actions-button"
        aria-controls={open ? "organization-actions-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          width: "32px",
          height: "32px",
          padding: 0,
          "&:hover": { backgroundColor: "rgba(208, 188, 255, 0.08)" },
        }}
        data-testid="organization-actions-button"
      >
        <MoreVertIcon sx={{ width: "20px", height: "20px" }} />
      </IconButton>
      <Menu
        id="organization-actions-menu"
        MenuListProps={{ "aria-labelledby": "organization-actions-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEdit} data-testid="edit-organization">
          Edit Organization Info
        </MenuItem>
        <MenuItem onClick={handleDelete} data-testid="delete-organization">
          Delete Organization
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default OrganizationActionsMenu;
